import { createSelector } from '@ngrx/store';
import { PreAuthorizedDebitMode } from '@arc/unified-payments-frontend/shared-payment';
import {
  selectIsBuyerOriginApp,
  selectIsCountryCanada,
} from '../session-store';
import { selectPreAuthorizedDebitMode } from '../payment-rules';
import {
  selectHasBankAccounts,
  selectHasNonSelectedBankAccounts,
} from '../btpay';

export const selectIsCanadianPadRequiredFlow = createSelector(
  selectPreAuthorizedDebitMode,
  selectIsCountryCanada,
  selectIsBuyerOriginApp,
  (mode, countryIsCanada, isBuyer) =>
    mode == PreAuthorizedDebitMode.Required && countryIsCanada && isBuyer,
);

export const selectIsCanadianPadOptionalFlow = createSelector(
  selectPreAuthorizedDebitMode,
  selectIsCountryCanada,
  selectIsBuyerOriginApp,
  (mode, countryIsCanada, isBuyer) =>
    mode == PreAuthorizedDebitMode.Optional && countryIsCanada && isBuyer,
);

export const selectIsCanadianPadRequiredOrOptionalFlow = createSelector(
  selectPreAuthorizedDebitMode,
  selectIsCountryCanada,
  selectIsBuyerOriginApp,
  (mode, countryIsCanada, isBuyer) =>
    (mode == PreAuthorizedDebitMode.Required ||
      mode == PreAuthorizedDebitMode.Optional) &&
    countryIsCanada &&
    isBuyer,
);

export const selectShouldLoadPadVerifiedStatus = createSelector(
  selectIsCanadianPadRequiredOrOptionalFlow,
  selectHasBankAccounts,
  (isCanadianPadRequiredOrOptionalFlow, hasBankAccounts) =>
    isCanadianPadRequiredOrOptionalFlow && hasBankAccounts,
);

export const selectShouldReLoadPadVerifiedStatus = createSelector(
  selectIsCanadianPadRequiredOrOptionalFlow,
  selectHasNonSelectedBankAccounts,
  (isCanadianPadRequiredOrOptionalFlow, hasNonSelectedBankAccounts) =>
    isCanadianPadRequiredOrOptionalFlow && hasNonSelectedBankAccounts,
);
